// extracted by mini-css-extract-plugin
module.exports = {"titlebar":"InfoPopup_titlebar__3KzA_","titlebar_icon":"InfoPopup_titlebar_icon__1QU4f"};